import React, { useEffect, useState } from "react";
import client from "@/lib/apiClient";

const GALLERY = [
  { url: "https://images.unsplash.com/photo-1663530761401-15eefb544889?crop=entropy&cs=srgb&fm=jpg&q=85&w=600", tag: "Restaurant Ad" },
  { url: "https://images.unsplash.com/photo-1764694071508-e4b1efcd39bc?crop=entropy&cs=srgb&fm=jpg&q=85&w=600", tag: "Product Ad" },
  { url: "https://images.unsplash.com/photo-1674305281997-b6538532f388?crop=entropy&cs=srgb&fm=jpg&q=85&w=600", tag: "AI Image" },
  { url: "https://images.unsplash.com/photo-1600096194534-95cf5ece04cf?crop=entropy&cs=srgb&fm=jpg&q=85&w=600", tag: "Social Post" },
  { url: "https://images.unsplash.com/photo-1615655406736-b37c4fabf923?crop=entropy&cs=srgb&fm=jpg&q=85&w=600", tag: "YouTube Thumbnail" },
  { url: "https://images.unsplash.com/photo-1620121684840-edffcfc4b878?crop=entropy&cs=srgb&fm=jpg&q=85&w=600", tag: "AI Image" },
  { url: "https://images.unsplash.com/photo-1572715376701-98568319fd0b?crop=entropy&cs=srgb&fm=jpg&q=85&w=600", tag: "Restaurant Ad" },
  { url: "https://images.unsplash.com/photo-1567359781514-3b964e2b04d6?crop=entropy&cs=srgb&fm=jpg&q=85&w=600", tag: "AI Image" },
];

// Named export so the Landing page can reuse the same fallback pool when the
// admin hasn't uploaded any custom tile images yet. Treat as read-only.
export { GALLERY };

export default function Examples() {
  const [items, setItems] = useState(null); // null = loading

  useEffect(() => {
    client.get("/gallery-items")
      .then(({ data }) => setItems(Array.isArray(data) ? data : []))
      .catch(() => setItems([]));
  }, []);

  // If admin has uploaded gallery items use those (order-respecting); otherwise
  // fall back to the built-in GALLERY so the page is never empty.
  const list = (items && items.length > 0)
    ? items.map((i) => ({ ...i, isVideo: i.type === "video" }))
    : GALLERY.map((g) => ({ url: g.url, tag: g.tag, type: "photo", isVideo: false }));

  return (
    <div className="mx-auto max-w-7xl px-5 py-16 sm:px-8">
      <div className="text-center">
        <p className="eyebrow text-primary">Gallery</p>
        <h1 className="mt-3 text-4xl font-extrabold tracking-tight sm:text-5xl">Made with AdGen Store</h1>
        <p className="mx-auto mt-4 max-w-xl text-muted-foreground">A glimpse of the creatives you can produce in seconds.</p>
      </div>
      <div className="mt-12 columns-2 gap-5 md:columns-3 lg:columns-4 [&>div]:mb-5">
        {list.map((g, i) => (
          <div key={g.id || i} className="group relative break-inside-avoid overflow-hidden rounded-xl border border-border" data-testid={`gallery-tile-${i}`}>
            {g.isVideo ? (
              <video src={g.url} muted loop playsInline autoPlay preload="metadata"
                     className="w-full object-cover transition-transform duration-500 group-hover:scale-105" />
            ) : (
              <img src={g.url} alt={g.tag || ""} className="w-full object-cover transition-transform duration-500 group-hover:scale-105" />
            )}
            {g.tag && <span className="absolute bottom-3 left-3 rounded-full bg-background/90 px-3 py-1 text-xs font-semibold">{g.tag}</span>}
          </div>
        ))}
      </div>
    </div>
  );
}
